import React from 'react';

function MessageIcons() {
    return (
        <>
            <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.47368 10.625H2.36842C1.61266 10.625 1 10.0094 1 9.25V2.375C1 1.61561 1.61266 1 2.36842 1H11.9474C12.7031 1 13.3158 1.61561 13.3158 2.375V6.5M14 10.625H9.21053M14 10.625L12.6316 9.25M14 10.625L12.6316 12M1 3.0625L6.39883 6.67902C6.85848 6.98696 7.45731 6.98696 7.91696 6.67902L13.3158 3.0625" stroke="black" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>

        </>
    );
}

export default MessageIcons;